// Категория: модуль с побочными эффектами (document, глобальный реестр подписчиков).
//
// Координатор выпадающих списков карточек. Решает две задачи:
//   1) закрыть открытый список по клику вне его — одним общим document-листенером,
//      а не отдельным на каждую из потенциально 50+ карточек;
//   2) закрыть чужие списки при открытии своего. Только document-листенера для этого
//      мало: карточки гасят всплытие на своём тоггле (иначе он сам себя закрывал бы),
//      поэтому клик по тогглу соседа до document не доходит и раньше оставлял
//      на экране два раскрытых списка сразу.
const subscribers = new Set();

const handleDocumentClick = () => {
    subscribers.forEach((close) => close());
};

/**
 * Регистрирует функцию закрытия и возвращает функцию отписки.
 * Листенер на document живёт, только пока есть хотя бы один подписчик.
 * @param close {Function}
 * @returns {Function}
 */
export function onOutsideClick(close) {
    if (!subscribers.size) {
        document.addEventListener('click', handleDocumentClick);
    }
    subscribers.add(close);

    return () => {
        subscribers.delete(close);
        if (!subscribers.size) {
            document.removeEventListener('click', handleDocumentClick);
        }
    };
}

/**
 * Закрывает все зарегистрированные списки, кроме своего. Вызывается тем,
 * кто собирается открыться.
 * @param self {Function} - собственная функция закрытия, полученная при регистрации
 */
export function closeOtherDropdowns(self) {
    subscribers.forEach((close) => {
        if (close !== self) {
            close();
        }
    });
}
